import React from 'react';
import { getTheme, useThemeMode } from '../theme';

/** Centrerad spinner med text. */
export function Loader({ text = 'Laddar...' }: { text?: string }) {
  const { mode } = useThemeMode();
  const T = getTheme(mode);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 20px' }}>
      <div style={{ width: 32, height: 32, border: `3px solid ${T.border}`, borderTopColor: T.amber, borderRadius: '50%', animation: 'spin 0.8s linear infinite', marginBottom: 16 }} />
      <div style={{ color: T.textSub, fontSize: 13 }}>{text}</div>
    </div>
  );
}

/** Tom-state med rubrik och undertext. */
export function Empty({ title, sub }: { emoji?: string; title: string; sub: string }) {
  const { mode } = useThemeMode();
  const T = getTheme(mode);
  return (
    <div style={{ textAlign: 'center', padding: '80px 20px' }}>
      <div style={{ color: T.text, fontSize: 16, fontWeight: 600 }}>{title}</div>
      <div style={{ color: T.textSub, fontSize: 13, marginTop: 4 }}>{sub}</div>
    </div>
  );
}

/** Färgad badge-tagg. */
export function Bdg({ label, color }: { label: string; color: string }) {
  return (
    <span style={{ background: `${color}22`, color, fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 10, border: `1px solid ${color}44` }}>
      {label}
    </span>
  );
}
